import { render, staticRenderFns } from "./DashboardSuper.vue?vue&type=template&id=72e48e7c&"
import script from "./DashboardSuper.vue?vue&type=script&lang=js&"
export * from "./DashboardSuper.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSuper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports